<template>
<section class="container deviceOverview">
	<div class="row">
		<v-heading :level="3" v-if="checkOverview">Apparaten overzicht</v-heading>
		<v-heading :level="3" v-else>Apparaten toewijzen</v-heading>
		<v-button class="btn btn--hollow btn--md deviceOverview__resetFilters"
    @click.native.prevent="resetFilters">
			<v-reset-icon></v-reset-icon>
			Reset filters
		</v-button>
	</div>
	<div class="row grid-margin">
		<div class="col-xs-12 col-md-4 deviceOverview__deviceSearch">
			<label class="deviceOverview__labels">Zoeken op apparaten</label>
      <v-input-group-simple-2
        v-model="searchDeviceDetails.serialNumber"
        :overwriteValue="searchDeviceDetails.serialNumber"
        :rules="{
          required: false
        }"
        id="deviceSerialNumber"
        placeholder="Zoek op serienummer"
        :showSearchIcon="!(awaitingSearch || deviceSearchLoadingStatus)"
        @input="searchDevices($event)"
      >
      </v-input-group-simple-2>
      <sync-loader v-if="awaitingSearch || deviceSearchLoadingStatus" :color="color"></sync-loader>
		</div>
		<div class="col-xs-12 col-md-2">
			<label class="deviceOverview__labels">Locatie</label>
				<v-select-group
          :disabled="!checkOverview"
          v-model="searchDeviceDetails.location"
          :overwriteValue="searchDeviceDetails.location"
          :initselected="searchDeviceDetails.location"
          selectid="deviceLocationId"
          @change="changeDeviceDetails($event, 'location')">
            <option v-for="(item, index) in location"
                  :key="'location' + index"
                  :data-index="'location' + index"
                  :value="item.text"
                  :selected="item.selected">{{ item.text }}</option>
				</v-select-group>
		</div>
		<div class="col-xs-12 col-md-3">
			<label class="deviceOverview__labels">Onderhoudsstatus</label>
				<v-select-group
          v-model="searchDeviceDetails.maintenanceStatus"
          :overwriteValue="searchDeviceDetails.maintenanceStatus"
          :initselected="searchDeviceDetails.maintenanceStatus"
          selectid="deviceStatusId"
          @change="changeDeviceDetails($event, 'maintenanceStatus')">
            <option v-for="(item, index) in maintenanceStatus"
                  :key="'status' + index"
                  :data-index="'status' + index"
                  :value="item.text"
                  :selected="item.selected">{{ item.text }}</option>
				</v-select-group>
		</div>
		<div class="col-xs-12 col-md-3">
			<label class="deviceOverview__labels">Vakantieapparatuur</label>
				<v-select-group
          v-model="searchDeviceDetails.isHolidayDevice"
          :overwriteValue="searchDeviceDetails.isHolidayDevice"
          :initselected="searchDeviceDetails.isHolidayDevice"
          selectid="holidayDeviceId"
          @change="changeDeviceDetails($event, 'isHolidayDevice')">
            <option v-for="(item, index) in isHolidayDevice"
                  :key="index + 1"
                  :data-index="index + 1"
                  :value="item.text"
                  :selected="item.selected">{{ item.text }}</option>
				</v-select-group>
		</div>
	</div>
  <div class="row">
    <v-table>
      <thead>
        <v-header-row :data="deviceHeader" :showSort="false" :page="'Apparatenoverzicht'"></v-header-row>
      </thead>
      <v-device-overview-row
        v-for="(row, index) in finalDevices"
        :data="row"
        :key="index"
        :index="index"
        :overviewStatus="checkOverview"
        :patientStatus="checkPatientStatus"
        @retourDevice="retourDeviceManagerEquipments"
        >
      </v-device-overview-row>
    </v-table>
  </div>
  <div class="row grid-align-middle">
    <paginate
      :page-count="totalPages"
      :page-range="3"
      :margin-pages="2"
      :click-handler="setPagination"
      :prev-text="'Vorige'"
      :next-text="'Volgende'"
      :container-class="'pagination'"
      :page-class="'page-item'">
    </paginate>
  </div>
</section>
</template>

<script>
import Paginate from 'vuejs-paginate'
import VTable from '@/components/shared/table/Table'
import VHeaderRow from '@/components/shared/table/rows/HeaderRow'
import VResetIcon from 'icons/Refresh'
import VDeviceOverviewRow from './deviceOverviewRow'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import router from '@/router'
import {
  allDeviceManagerEquipments$,
  invalidateAllDeviceManagerEquipments$
} from '@/services'

export default {
  name: 'deviceOverview',
  components: {
		VTable,
		VHeaderRow,
		VResetIcon,
    VDeviceOverviewRow,
    SyncLoader,
    Paginate
  },
  computed: {
    checkOverview () {
      return router.currentRoute.name === 'deviceOverview'
    },
    checkPatientStatus () {
      return router.currentRoute.name === 'deviceAllocate'
    }
  },
  data () {
    return {
      color: '#73c8d2',
      deviceSearchLoadingStatus: false,
      awaitingSearch: false,
      typeSleep: 0,
      searchDeviceDetails: {},
      location: [
        { id: 0, text: 'Toon alles', selected: true},
        { id: 1, text: 'In depot', selected: false},
        { id: 2, text: 'Bij patiënt', selected: false},
        { id: 3, text: 'Bij mediq', selected: false},
        { id: 4, text: 'Naar mediq', selected: false},
      ],
      maintenanceStatus: [
        { id: 0, text: 'Toon alles', selected: true},
        { id: 1, text: 'Gereed', selected: false},
        { id: 2, text: 'In behandeling', selected: false},
        { id: 3, text: 'Gepland', selected: false},
        { id: 4, text: 'In onderhoud', selected: false},
        { id: 5, text: 'Vertraagd', selected: false}
      ],
      isHolidayDevice: [
        { id: 0, text: 'Toon alles', value: 'Toon alles', selected: true},
        { id: 1, text: 'Nee', value: false, selected: false},
        { id: 2, text: 'Ja', value: true, selected: false}
      ],
      filters: ['location', 'maintenanceStatus', 'isHolidayDevice'],
      deviceHeader: ['', 'Omschrijving', 'Serienummer', 'Locatie', 'Onderhoudsstatus', 'Gepland onderhoud', ''],
      devices: [],
      computedDevices: [],
      finalDevices: [],
      rowsPerPage: 10,
      totalPages: 0,
      paginationData: {}
    }
  },
  subscriptions () {
    return {
      devices: allDeviceManagerEquipments$
    };
  },
  created () {},
  watch:{
    devices (value) {
      if (value) {
        this.computedDevices = value
        this.setSearchDeviceDetails()
        this.setPagination(1)
      }
    }
  },
  methods: {
    setPagination (pageNumber) {
      this.finalDevices = []
      pageNumber = pageNumber > 0 ? pageNumber : 1
      var totalResult = this.computedDevices.length
      this.totalPages = Math.ceil(totalResult / this.rowsPerPage)
      var startIndex = (pageNumber - 1) * this.rowsPerPage
      var endIndex = startIndex + this.rowsPerPage
      for(var i = startIndex; i < endIndex; i++) {
        if (this.computedDevices[i] !== undefined) {
          this.finalDevices.push(this.computedDevices[i])
        }
      }
    },
    setSearchDeviceDetails () {
      this.searchDeviceDetails = {
        serialNumber: '',
        location: 'Toon alles',
        maintenanceStatus: 'Toon alles',
        isHolidayDevice: 'Toon alles'
      }
      if (!this.checkOverview) {
        this.searchDeviceDetails.location = 'In depot'
        this.getComputedDevices()
      }
    },
		resetFilters () {
      this.setSearchDeviceDetails()
      this.filters.forEach((item) => {
        for (let i=0; i < this[item].length; i++) {
          if(i === 0) {
            if (!this.checkOverview && item === 'location') {
              this[item][i].selected = false
            } else {
              this[item][i].selected = true
            }
          } else {
            if (!this.checkOverview && item === 'location') {
              this[item][i].selected = true
            } else {
              this[item][i].selected = false
            }
          }
        }
      })
      if (this.checkOverview) {
        this.computedDevices = this.devices
      }
      this.setPagination(1)
		},
    changeDeviceDetails(event, key) {
      this[key].forEach((item) => {
        if (item.text === event.target.value) {
          item.selected = true
          this.searchDeviceDetails[key] = event.target.value
          this.getComputedDevices()
        } else {
          item.selected = false
        }
      })
    },
    finishTyping (term) {
      // Based on research of the average CPM (200) typing speed
      // Haults request to wait till user is finished typing by calculating keystroke time
      this.typeSleep += 1
      setTimeout(() => {
        this.typeSleep -= 1
        if (this.typeSleep === 0) {
          this.awaitingSearch = false
          if (term.length > 2) {
            if (!this.deviceSearchLoadingStatus && term.length !== 0) {
              this.serialNumberSearch()
            } else {
              this.deviceSearchLoadingStatus = false
              this.finishTyping(term)
            }
          }
          if (term.length === 0) {
            this.resetFilters()
          }
        }
      }, 300);
      this.awaitingSearch = true
    },
    searchDevices (event) {
      if (event.target.value.length > 2) {
        this.deviceSearchLoadingStatus = true
        this.resetFilters()
        this.searchDeviceDetails.serialNumber = event.target.value
      } else {
        this.deviceSearchLoadingStatus = false
      }
      this.finishTyping(event.target.value)
    },
    getComputedDevices () {
      this.computedDevices = this.devices
      let filterCount = 0
      for (let key in this.searchDeviceDetails) {
        if (key !== 'serialNumber' && this.searchDeviceDetails[key] !== 'Toon alles') {
          filterCount = filterCount + 1
        }
      }
      this.computedDevices = this.computedDevices.filter((device) => {
        let count = 0
        this.filters.forEach((key) => {
          if (key === 'isHolidayDevice') {
            let computedValue = false
            if (this.searchDeviceDetails[key] === 'Ja') {
              computedValue = true
            }
            if (this.searchDeviceDetails[key] !== 'Toon alles' && device[key] === computedValue) {
              count = count + 1
            }
          } else {
            if (this.searchDeviceDetails[key] !== 'Toon alles' && device[key].toLowerCase() === this.searchDeviceDetails[key].toLowerCase()) {
              count = count + 1
            }
          }
        })
        if (count === filterCount) {
          return device
        }
      })
      this.setPagination(1)
      return this.comuptedDevices
    },
    serialNumberSearch () {
      this.computedDevices = this.computedDevices.filter((device) => {
        if (device.serialNumber && device.serialNumber.toLowerCase().indexOf(this.searchDeviceDetails.serialNumber.toLowerCase()) !== -1) {
          return true
        } else if (device.externalSerialNumber && device.externalSerialNumber.toLowerCase().indexOf(this.searchDeviceDetails.serialNumber.toLowerCase()) !== -1) {
          return true
        }
      })
      this.setPagination(1)
    },
    retourDeviceManagerEquipments () {
      invalidateAllDeviceManagerEquipments$()
    }
  }
}
</script>
<style lang="scss" scoped>
.deviceOverview {
  .pagination {
    margin: 20px auto auto auto;
  }
  &__deviceSearch {
    position: relative;
  }
	&__labels {
		font-size: 18px;
  	font-weight: bold;
		color: $teal-darkest;
		margin-bottom: 10px;
    overflow: hidden;
	}
	&__resetFilters {
    margin: 0px 0px 15px 15px;
    .material-design-icon {
      margin-right: 5px;
    }
	}
	/deep/
	.form-group-simple {
		input {
			border-color: $white;
		}
	}
  /deep/
  .disabled {
    input {
      border-color: $gray !important;
    }
  }
	/deep/
	.form-group {
		padding: 0px;
    .form-group__details {
      &:before {
        background: none;
      }
      &:after {
        background: none;
      }
    }
    &__icon {
      margin: -5px 35px 0px 0px;
    }
    &--hasvalue label {
      display: none;
    }
    &--disabled {
      background: none !important;
      border-radius: 0 !important;
      label {
        padding: 0px !important;
      }
    }
	}
}
</style>
